import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { EmployeeAuditLogResponse } from "../model/EmployeeAuditEntry";
import EmployeeAuditLogRequest from "../request/EmployeeAuditLogRequest";

export const EmployeeAuditLogApiService = async (
  request: EmployeeAuditLogRequest
): Promise<EmployeeAuditLogResponse> => {
  const { employee_id: employeeId, fields, sources, ...rest } = request;
  const normalizedFields = fields?.length ? fields.join(",") : undefined;
  const normalizedSources = sources?.length ? sources.join(",") : undefined;
  const url = `/employees/${employeeId}/audit-log/`;
  const { data } = await axios.get(url, {
    params: {
      ...rest,
      fields: normalizedFields,
      sources: normalizedSources,
    },
  });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeAuditLogApiService = (request: EmployeeAuditLogRequest) =>
  useQuery<EmployeeAuditLogResponse, AxiosError>(
    [
      "EmployeeAuditLogApiService",
      request.employee_id,
      request.page,
      request.page_size,
      request.date_from,
      request.date_to,
      request.fields?.length ? request.fields.join(",") : undefined,
      request.sources?.length ? request.sources.join(",") : undefined,
    ],
    () => EmployeeAuditLogApiService(request),
    { keepPreviousData: true }
  );

export default useEmployeeAuditLogApiService;
